import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Container, Header } from "semantic-ui-react";
import API from "../../API/API";
import SliderFullWidthComponent from "../../components/SliderFullWidthComponent";
import SliderNavComponent from "../../components/SliderNavComponent";
import Especificaciones from "./Especificaciones";
import Descripcion from "./PropertyDescription";
import MetaTagComp from "../../components/MetaTagComp";

class DetallePropiedad extends React.Component {
  constructor(props) {
    super(props);
    this.didGetData = false;
  }
  state = {
    specProps: { finishes: [], images: [] }
  };

  componentDidMount() {
    console.log(this.props.data);
    const idproperty = window.location.pathname.split("detalle/")[1];
    const propertieFind = this.props.data.find(propertieTemp => {
      return propertieTemp.url === idproperty;
    });
    console.log(propertieFind);
    if (propertieFind !== undefined) {
      if (propertieFind.id !== undefined) {
        this.didGetData = true;
        const api = new API();
        api.getDevelopmentProperty(propertieFind.id).then(response => {
          this.setState({ specProps: response[0] });
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    console.log(nextProps.data);
    console.log(this.state.specProps);
    if (this.state.specProps.id !== undefined || this.didGetData === false) {
      const idproperty = window.location.pathname.split("detalle/")[1];
      const propertieFind = nextProps.data.find(propertieTemp => {
        return propertieTemp.url === idproperty;
      });
      if (propertieFind !== undefined) {
        if (
          propertieFind.id !== undefined &&
          this.state.specProps.id !== propertieFind.id
        ) {
          if (propertieFind.id !== this.state.specProps.id) {
            const api = new API();
            api.getDevelopmentProperty(propertieFind.id).then(response => {
              console.log(response[0]);
              this.setState({ specProps: response[0] });
            });
          }
        }
      }
    }
  }

  render() {
    let amenitiesshow = this.props.data;
    return (
      <div className="marginTop">
        {this.state.specProps.name !== undefined && (
          <MetaTagComp
            section={"home"}
            replaceMetaTags={[
              {
                name: "title",
                content: "Dream Lagoons | " + this.state.specProps.name
              },
              {
                name: "description",
                content: this.state.specProps.description
              }
            ]}
          />
        )}
        <Container>
          <Header
            as="h2"
            className="title"
            style={{
              color: "#5594b7",
              fontSize: "40px",
              textAlign: "center",
              marginBottom: "40px"
            }}
          >
            Especificaciones
          </Header>

          <Especificaciones specsData={this.state.specProps} />
          <Descripcion descData={this.state.specProps} />
        </Container>
        <div>
          <SliderFullWidthComponent slider={this.state.specProps.images} />
        </div>

        <Container className="marginTop">
          <SliderNavComponent url={this.props.url} slider={amenitiesshow} />
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({ data }) => {
  const { developmentProperties } = data;
  return {
    developmentProperties
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    {}
  )(DetallePropiedad)
);
